<script setup lang="ts">
interface ContentBlock {
  blockType: 'intro' | 'archive' | 'current-and-upcoming'
  id?: string | null
  blockName?: string | null
  title?: string
  description?: any
  useMask?: boolean | null
  image?: Media | null
  maskedMedia?: MaskedMedia | null
  archiveViewOption?: 'title' | 'date' | 'grouped-by-year' | 'grouped-by-year-title-only' | 'thumbnails' | 'image'
  sortOption?: 'newest' | 'oldest' | 'az' | 'za'
  currentAndUpcomingViewOption?: 'title' | 'thumbnails'
}

defineProps<{
  blocks: ContentBlock[]
  typeSlug: string
  typeId: string
}>()
</script>

<template>
  <div
    class="flex flex-col gap-3"
  >
    <template v-for="block in blocks" :key="block.id">
      <pages-programme-type-block-intro
        v-if="block.blockType === 'intro'"
        :title="block.title"
        :description="block.description"
        :use-mask="block.useMask"
        :image="block.image"
        :masked-media="block.maskedMedia"
      />

      <pages-programme-type-block-archive
        v-else-if="block.blockType === 'archive'"
        :title="block.title"
        :description="block.description"
        :use-mask="block.useMask"
        :image="block.image"
        :masked-media="block.maskedMedia"
        :view-option="block.archiveViewOption"
        :sort-option="block.sortOption"
        :type-slug="typeSlug"
        :type-id="typeId"
      />

      <pages-programme-type-block-current-and-upcoming
        v-else-if="block.blockType === 'current-and-upcoming'"
        :title="block.title"
        :description="block.description"
        :use-mask="block.useMask"
        :image="block.image"
        :masked-media="block.maskedMedia"
        :view-option="block.currentAndUpcomingViewOption"
        :type-slug="typeSlug"
        :type-id="typeId"
      />
    </template>
  </div>
</template>
